// Reception stat tiles — RON-5469. Prototype region: `.stats` (five tiles).
//
// EVERY NUMBER HERE COMES FROM `counts` ON THE BOARD (§3). Nothing is recomputed from the rows on
// screen, for two reasons:
//
//   1. The API returns all seven counts ONCE and the filter tabs read the same object, so the two
//      regions cannot disagree.
//   2. The counts describe the whole day and site regardless of `filter` and `q`, while the rows
//      on screen are narrowed by both. Counting the visible rows would make "On site 47" drop to
//      "On site 3" the moment somebody typed in the search box.
//
// The prototype's trend chips ("12% up", "vs avg") are NOT rendered. §9: there is still no source
// for a rolling per-site average, and an invented trend on a reception screen is a number somebody
// repeats in a meeting.

import { useTranslation } from "react-i18next";

import { RELATIVE_DAY, STAT_TILES, getStatLabelKey } from "../receptionConstants.js";

const ReceptionStats = ({ counts, isLoading, relativeDay = RELATIVE_DAY.TODAY }) => {
  const { t } = useTranslation("common");

  return (
    // ONE strip divided by rules, not five cards. The five numbers are read together — "6 on site,
    // 5 expected, 1 overstaying" is a single sentence about the building — and separate cards with
    // gaps invite the eye to take them one at a time.
    <section className="reception-stats">
      {STAT_TILES.map((tile) => (
        <div key={tile.key} className={`reception-stat reception-stat--${tile.tone}`}>
          <div className="reception-stat__label">
            {/* Decorative: the label beside it already says what the number is, so it is hidden
                from assistive tech rather than read out as punctuation. */}
            <span className="reception-stat__icon" aria-hidden="true">
              {tile.icon}
            </span>
            {/* The label carries TENSE. On a finished day "On site 0" claims the building is
                empty; "Were on site 0" is the same number telling the truth. */}
            <span className="reception-stat__name">
              {t(getStatLabelKey(tile, relativeDay))}
            </span>
          </div>
          <div className="reception-stat__value" data-stat={tile.key}>
            {/* An em dash while loading rather than 0. A reception screen briefly reading
                "On site 0" is a statement about the building, not a loading state. */}
            {isLoading ? "—" : counts?.[tile.countKey] ?? 0}
          </div>
        </div>
      ))}
    </section>
  );
};

export default ReceptionStats;
